import React from 'react';
import style from './style.module.css';

const Description = ({ description, value, small }) => {
  return (
    <div className={small ? style.smallWrapper : style.wrapper}>
      <p>{description}</p>
      <p>{value}</p>
    </div>
  );
};

export default Description;
